// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__nRNk2 {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}

.styles_title__2XWl7 {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  color: #696969;
}

.styles_inputContainer__RfXMw {
  margin-bottom: 30px;
  width: 100%;
}

.styles_inputContainerMobile__dLc3z {
  width: calc(100% - 100px);
}

.styles_inputContainerCode__jIw-U {
  width: 80px;
}

.styles_wrapper__zwaSL {
  width: 100%;
}

.styles_text__A8qTe {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
  padding: 1em 0;
}

.styles_bottomPart__6UNf5 {
  border-top: 1px solid #f3f2f2;
  width: 100%;
  height: auto;
  box-sizing: border-box;
  padding-top: 1em;
}

.styles_goToLoginText__EhGLA {
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 20px;
  color: #707070;
}

.styles_goToLoginText__EhGLA span {
  font-style: normal;
  font-weight: 500;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: #d8000d;
  cursor: pointer;
}

.styles_inputError__\\+C70a {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315;
  margin-top: 8px;
}

.styles_serverError__2z8nc {
  background: #ff9315;
  border-radius: 4px;
  color: #ffffff;
  width: 100%;
  height: auto;
  padding: 0.5em;
  margin-bottom: 1em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}

.styles_serverError__2z8nc span {
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 20px;
  padding: 0 2px;
}

.styles_inputStyle__LAB3L {
  width: 420px !important;
}

.styles_formButton__ZMw16 {
  width: 100% !important;
}

.styles_formButton__ZMw16 > button {
  width: 100% !important;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.styles_formButton__ZMw16 input {
  width: 100% !important;
}

@media only screen and (max-width: 1024px) {
  .styles_inputStyle__LAB3L {
    width: 100% !important;
  }
  .styles_text__A8qTe {
    max-width: 353px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/ForgetPasswordMobile/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;AACF;;AAEA;EACE,mBAAA;EACA,WAAA;AACF;;AAEA;EACE,yBAAA;AACF;;AAEA;EACE,WAAA;AACF;;AAGA;EACE,WAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,cAAA;AAAF;;AAGA;EACE,6BAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,eAAA;AAAF;;AAGA;EACE,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;AAAF;;AAGA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;AAAF;;AAGA;EACE,uBAAA;AAAF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AADF;;AAIA;EACE,sBAAA;AADF;;AAIA;EACE;IACE,sBAAA;EADF;EAKA;IACE,gBAAA;EAHF;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.title {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 20px;\n  text-align: center;\n  color: #696969;\n}\n\n.inputContainer {\n  margin-bottom: 30px;\n  width: 100%;\n}\n\n.inputContainerMobile {\n  width: calc(100% - 100px);\n}\n\n.inputContainerCode {\n  width: 80px;\n  // margin: 0 10px;\n}\n\n.wrapper {\n  width: 100%;\n}\n\n.text {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n  padding: 1em 0;\n}\n\n.bottomPart {\n  border-top: 1px solid #f3f2f2;\n  width: 100%;\n  height: auto;\n  box-sizing: border-box;\n  padding-top: 1em;\n}\n\n.goToLoginText {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 14px;\n  line-height: 20px;\n  color: #707070;\n}\n\n.goToLoginText span {\n  font-style: normal;\n  font-weight: 500;\n  font-weight: bold;\n  font-size: 14px;\n  line-height: 20px;\n  color: #d8000d;\n  cursor: pointer;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315;\n  margin-top: 8px;\n}\n\n.serverError {\n  background: #ff9315;\n  border-radius: 4px;\n  color: #ffffff;\n  width: 100%;\n  height: auto;\n  padding: 0.5em;\n  margin-bottom: 1em;\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n}\n\n.serverError span {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 20px;\n  padding: 0 2px;\n}\n\n.inputStyle {\n  width: 420px !important;\n  // height: 44px;\n}\n\n.formButton {\n  width: 100% !important;\n}\n\n.formButton>button {\n  width: 100% !important;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: normal;\n}\n\n.formButton input {\n  width: 100% !important;\n}\n\n@media only screen and (max-width: 1024px) {\n  .inputStyle {\n    width: 100% !important;\n    // height: 44px;\n  }\n\n  .text {\n    max-width: 353px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__nRNk2`,
	"title": `styles_title__2XWl7`,
	"inputContainer": `styles_inputContainer__RfXMw`,
	"inputContainerMobile": `styles_inputContainerMobile__dLc3z`,
	"inputContainerCode": `styles_inputContainerCode__jIw-U`,
	"wrapper": `styles_wrapper__zwaSL`,
	"text": `styles_text__A8qTe`,
	"bottomPart": `styles_bottomPart__6UNf5`,
	"goToLoginText": `styles_goToLoginText__EhGLA`,
	"inputError": `styles_inputError__+C70a`,
	"serverError": `styles_serverError__2z8nc`,
	"inputStyle": `styles_inputStyle__LAB3L`,
	"formButton": `styles_formButton__ZMw16`
};
export default ___CSS_LOADER_EXPORT___;
